import React, { Component, useEffect, useState } from "react";
import styled from "styled-components";
import { useParams } from "react-router-dom";
import {
  Time as TimeIcon,
  CheckCirclIcon,
} from "../../../components/svgs";
import {
  Body,
  Children,
  DynamicButton,
  MainHolder,
  StyledText,
} from "../../../components/common/basic";

import { logEvent } from "firebase/analytics";
import analytics from "../../../context/analytics";
import RewardItemCard from "./components/RewardItemCard";
import { BackButton, OrderStatusCard } from "../../../components/common";
import useTriviaOrders from "./hooks/useTriviaOrders";
import { useTheme, useTrivia } from "../../../hooks";
import useTriviaPickup from "./hooks/useTriviaPickup";

const TriviaOrderDetails = () => {
  useEffect(() => {
    analytics().then(anl => logEvent(anl, "screen_view", {
      firebase_screen: "MashupAndWinOrderDetails",
      firebase_screen_class: "MashupAndWinOrderDetails",
    }));
  }, []);

  const {
    background,
    history,
    order,
    item,
    unitPoints,
    getOrder,
  } = useTriviaOrders();

  const { voucherData } = useTriviaPickup();

  const { activeTrivia, getTrivia } = useTrivia();
  const { userStats: { wonData } = {} } = activeTrivia
  const { value, voucher, pickupLocation, pickupRegion, referenceCode, hasRedeemed } = wonData || {}

  const { orderId } = useParams();

  useEffect(() => {
    if (orderId) {
      getOrder(orderId);
    }
  }, [orderId])

  useEffect(() => {
    if (activeTrivia) {
      const { userStats } = activeTrivia;
      const { wonData } = userStats || {};
      const { hasRedeemed } = wonData;
      if (hasRedeemed) history.push('/trivia/trivia-category')
    }
  }, [activeTrivia])

  const goToHome = () => {
    const token = JSON.parse(localStorage.getItem("token"));
    history.push(`/home?token=${token}`);
  };
  const { themeContext, theme } = useTheme();

  const themeColor = theme.colors[themeContext.activeTheme]["background"];

  return (
    <>
      <MainHolder>
        <div>
          <BackButton onClick={() => { goToHome(); getTrivia() }} />
          <StyledText style={{ marginLeft: '29%', marginTop: '5%' }}>Redemption details</StyledText>
        </div>
        <Children>
          <Header>
          </Header>
          <Body>
            <div style={{ boxSizing: 'border-box', padding: '0 15px' }}>
              {
                !order &&
                <>
                  <RewardItemCard
                    color={background}
                    image={voucherData[voucher]?.imageUrl}
                    name={voucherData[voucher]?.name}
                    points={`${value ? 'GHS' + value : 'Reward'}`}
                  />
                  <StyledText>
                    <span style={{ color: '#7F7F7F' }}>Reference code:  </span>
                    {referenceCode}
                  </StyledText>
                  <StyledText size={11}>
                    <span style={{ color: '#7F7F7F' }}>Pickup point </span>
                    {pickupRegion}, {pickupLocation}
                  </StyledText>

                  {activeTrivia?.title === "Deadpool and Wolverine" && <StyledText size={12}  color="red">
                    Please note that this ticket is valid only for use on Thursday, July 25th, at 6:00 PM
                  </StyledText>}

                  <hr style={{ margin: '15px 0', borderTop: 'none', borderBottom: '1px solid #ddd' }} />

                  <StyledText size={18}>Order Status</StyledText>
                  <OrderStatusCard
                    location={pickupLocation}
                    arrivalDate={activeTrivia?.title === "Deadpool and Wolverine" ? "July 18 - July 25" : null}
                    stage={"in-progress"}
                    enrouteDate={null}
                    completedDate={null}
                  />

                  <DynamicButton
                    onClick={() => history.push('/trivia/redeem-onground')}
                    label={"Complete redemption (Staff only)"}
                    fullWidth
                    color={themeColor}
                  />
                </>
              }
            </div>
          </Body>
        </Children>
      </MainHolder>
    </>
  );
};


const Header = styled.div`
  /* width: 360px; */
  overflow: hidden;
  padding: 20px 20px 10px 20px;
  background-color: ${({ background }) => background};
  position: relative;
`;

export default TriviaOrderDetails;
